import {createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../../../middleware/api';
import {notify} from '../../../modules/notifier/services/actions';
import {UpdatePeriodParams} from '../typedef';
import {PeriodDto} from '../../../dto/PeriodDto';

export const getPeriods = createAsyncThunk(
    'periods/getPerions',
    async (projectId: number, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `periods/project/${projectId}`,
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return responseData as PeriodDto[];
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const updatePeriod = createAsyncThunk(
    'periods/updatePeriod',
    async (params: UpdatePeriodParams, {dispatch, rejectWithValue, requestId}) => {
        const {periodId, locked} = params;
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: `periods/${periodId}?isLocked=${locked}`,
            method: ApiMethods.PUT
        });
        if (httpStatus === 200) {
            dispatch(notify({message: 'Success', key: requestId, variant: 'success'}));
            return params;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const openPeriods = createAsyncThunk(
    'periods/openPeriods',
    async (projectIds: number[], {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: 'periods/open',
            method: ApiMethods.POST
        });
        if (httpStatus === 200) {
            projectIds.forEach((projectId) => {
                dispatch(getPeriods(projectId));
            });
            dispatch(notify({message: 'Success', key: requestId, variant: 'success'}));
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);
